//#region Musiikki ja äänet

import { mobileOrNot } from "~/src/helpers/mobileDetect.js";

const createSounds = (scene) => {
  let spatialSounds = !mobileOrNot()
 // if (mobileOrNot()) return {};
  // Voimakkuus ! voimakkuuden säätö pitää vielä tehdä
  var volumeSoundtrack = 0.2;
  var volumeSounds = 0.5;
  var volumeSounds1 = 1;
  var volumeSounds2 = 1;

  // musiikki



  var musicFlat = new BABYLON.Sound(
    "musicFl",
    window.pakopeliPublicAssetUrl + "sound/converted/flat_ES_A_Family_Cursed_-_Farrell_Wooten.mp3",
    scene,
    null,
    { loop: true, volume: volumeSoundtrack, autoplay: true }
  );

  const musicWarehouse = new BABYLON.Sound(
    "musicWh",
    window.pakopeliPublicAssetUrl + "sound/converted/warehouse_ES_Drone_Dark_Low_1_-_SFX_Producer.mp3",
    scene,
    null,
    { loop: true, volume: volumeSoundtrack, autoplay: false }
  );
  const musicBunker = new BABYLON.Sound(
    "musicBk",
    window.pakopeliPublicAssetUrl + "sound/converted/bunker_ES_Basement_-_SFX_Producer.mp3",
    scene,
    null,
    { loop: true, volume: volumeSoundtrack, autoplay: false }
  );

  const musicExit = new BABYLON.Sound(
    "musicE",
    window.pakopeliPublicAssetUrl + "sound/converted/exit_ES_Sudden_Signs.mp3",
    scene,
    null,
    { loop: true, volume: volumeSoundtrack, autoplay: false }
  );

  var phone1Sound = new BABYLON.Sound(
    "soundP1",
    window.pakopeliPublicAssetUrl + "sound/converted/flat_phone_trimmed.mp3",
    scene,
    null,
    {
      loop: false,
      autoplay: false,
      volume: 0.4,
      maxDistance: 70,
      spatialSound: false,
    }
  );
  phone1Sound.setPosition(new BABYLON.Vector3(48, 4, -17));

  var phone2Sound = new BABYLON.Sound(
    "soundP2",
    window.pakopeliPublicAssetUrl + "sound/converted/warehouse_phone_trimmed.mp3",
    scene,
    null,
    {
      loop: false,
      autoplay: false,
      volume: 0.4,
      maxDistance: 90,
      spatialSound: false,
    }
  );
  phone2Sound.setPosition(new BABYLON.Vector3(41, 3, -105.92));

  var phone3Sound = new BABYLON.Sound(
    "soundP3",
    window.pakopeliPublicAssetUrl + "sound/converted/bunker_phone_trimmed.mp3",
    scene,
    null,
    {
      loop: false,
      autoplay: false,
      volume: 0.5,
      maxDistance: 90,
      spatialSound: false,
    }
  );
  phone3Sound.setPosition(new BABYLON.Vector3(135.26, -27.35, -145));


  //äänet
/*   const sphereMat = new BABYLON.StandardMaterial("sphereMat", scene);
  sphereMat.diffuseColor = BABYLON.Color3.Purple();
  sphereMat.backFaceCulling = false;
  sphereMat.alpha = 0;

  const sphereMusic1 = BABYLON.Mesh.CreateSphere("musicsphere", 20, 15, scene);
  sphereMusic1.material = sphereMat;
  sphereMusic1.position = new BABYLON.Vector3(183, -29, -135);

  const sphereMusic2 = BABYLON.Mesh.CreateSphere("musicsphere", 20, 15, scene);
  sphereMusic2.material = sphereMat;
  sphereMusic2.position = new BABYLON.Vector3(180, -29, -135); */
  
  let tvSound, computerSound, computerSound2, computerSound3, computerSound4;

  if (spatialSounds) {
    computerSound = new BABYLON.Sound(
      "flatComputer1Sound",
      window.pakopeliPublicAssetUrl + "sound/converted/computer_ES_Electric_Hum_-_SFX_Producer.mp3",
      scene,
      null,
      {
        loop: true,
        autoplay: true,
        volume: volumeSounds,
        maxDistance: 30,
        spatialSound: true,
      }
    );
    computerSound.setPosition(new BABYLON.Vector3(18, 9, -43));
    computerSound2 = new BABYLON.Sound(
      "flatComputer2Sound",
      window.pakopeliPublicAssetUrl + "sound/converted/computer_ES_Electric_Hum_-_SFX_Producer.mp3",
      scene,
      null,
      {
        loop: true,
        autoplay: false,
        volume: volumeSounds,
        maxDistance: 30,
        spatialSound: true,
      }
    );
    // email-tietokone
    computerSound2.setPosition(new BABYLON.Vector3(77, 5, -35));

     computerSound3 = new BABYLON.Sound(
      "warehouseComputerSound",
      window.pakopeliPublicAssetUrl + "sound/converted/computer_ES_Electric_Hum_-_SFX_Producer.mp3",
      scene,
      null,
      {
        loop: true,
        autoplay: false,
        volume: volumeSounds,
        maxDistance: 30,
        spatialSound: true,
      }
    );
    //Warehouse
    computerSound3.setPosition(new BABYLON.Vector3(35, 5, -220));

    computerSound4 = new BABYLON.Sound(
      "bunkerComputerSound",
      window.pakopeliPublicAssetUrl + "sound/converted/computer_ES_Electric_Hum_-_SFX_Producer.mp3",
      scene,
      null,
      {
        loop: true,
        autoplay: false,
        volume: volumeSounds,
        maxDistance: 30,
        spatialSound: true,
      }
    );
    computerSound4.setPosition(new BABYLON.Vector3(183, -29, -135));
  
  tvSound = new BABYLON.Sound(
    "tvSound",
    window.pakopeliPublicAssetUrl + "sound/converted/tvsound_ES_CB_Radio_Static_1.mp3",
    scene,
    null,
    {
      loop: true,
      autoplay: true,
      volume: volumeSounds,
      maxDistance: 30,
      spatialSound: true,
    }
  );
  tvSound.setPosition(new BABYLON.Vector3(39, 9.5, -5.2));
  
  }
  const fcDoorSound = new BABYLON.Sound(
    "soundFcDoor",
    window.pakopeliPublicAssetUrl + "sound/converted/flatCorridorSound_ES_Door_Creak_4_-_SFX_Producer.mp3",
    scene,
    null,
    { loop: false, autoplay: false, volume: volumeSounds1 }
  );


  const warehouseDoorSound = new BABYLON.Sound(
    "soundWhDoor",
    window.pakopeliPublicAssetUrl + "sound/converted/warehouseDoorSound.mp3",
    scene,
    null,
    { loop: false, autoplay: false, volume: volumeSounds }
  );
  const bunkerDoorSound = new BABYLON.Sound(
    "soundBkDoor",
    window.pakopeliPublicAssetUrl + "sound/converted/bunkerDoorSound.mp3",
    scene,
    null,
    { loop: false, autoplay: false, volume: volumeSounds }
  );
  const ecpSound = new BABYLON.Sound(
    "soundFcDoor",
    window.pakopeliPublicAssetUrl + "sound/converted/ECP_ES_PREL_Distortion_75.mp3",
    scene,
    null,
    { loop: false, autoplay: false, volume: volumeSounds }
  );
  //exit oven äänet
  const exitDoorSound = new BABYLON.Sound(
    "soundExitDoor",
    window.pakopeliPublicAssetUrl + "sound/converted/exitDoor_ES_Door_Creak_Wood_1.mp3",
    scene,
    null,
    { loop: false, autoplay: false, volume: 0.8 }
  );
  const exitDoor2Sound = new BABYLON.Sound(
    "soundExitDoor",
    window.pakopeliPublicAssetUrl + "sound/converted/exitdoor_ES_Static_Buzz_3.mp3",
    scene,
    null,
    { loop: false, autoplay: false, volume: 0.8 }
  );

  function exitDoorsSoundSet() {
    exitDoorSound.play(1);
    exitDoor2Sound.play();
  }

  function electricPanelSoundSet() {
    ecpSound.play();
    if (musicBunker?.isPlaying) {
    musicBunker.stop();
    }
    musicExit.play(1);
  }

  // askeläänet ! eivät toimi mobiilissa tällä koodilla
  //  const footSound = setInterval(footSteps, 500);
  const footSteps = new BABYLON.Sound(
    "footSteps",
    window.pakopeliPublicAssetUrl + "sound/converted/ES_Combat_Boots_Walk_2_-_SFX_Producer.mp3",
    scene,
    null,
    { loop: false }
  );


  const paperMovement = new BABYLON.Sound(
    "matrixPosterPaperMovement",
    window.pakopeliPublicAssetUrl + "sound/converted/ES_Paper_Movement_A4_-_SFX_Producer.mp3",
    scene,
    null,
    { loop: false, volume: volumeSoundtrack + 0.2, autoplay: false }
  );

  const paperRightPlace = new BABYLON.Sound(
    "matrixPosterRightPace",
    window.pakopeliPublicAssetUrl + "sound/converted/ES_Cardboard_Box_Set_Down_4_-_SFX_Producer.mp3",
    scene,
    null,
    { loop: false, volume: volumeSoundtrack, autoplay: false }
  );

  const matrixKeyboard = new BABYLON.Sound(
    "matrixKeyboard",
    window.pakopeliPublicAssetUrl + "sound/converted/ES_Apple_Keyboard_9_-_SFX_Producer.mp3",
    scene,
    null,
    { loop: false, volume: volumeSoundtrack, autoplay: false }
  );

  const twitterMouseClick = new BABYLON.Sound(
    "twitterMouseClick",
    window.pakopeliPublicAssetUrl + "sound/converted/ES_Mouse_Click_2_-_SFX_Producer.mp3",
    scene,
    null,
    { loop: false, volume: volumeSoundtrack, autoplay: false }
  );

  const exitDoorNotOpen = new BABYLON.Sound(
    "exitDoorNotOpen",
    window.pakopeliPublicAssetUrl + "sound/converted/FXrynkytys.mp3",
    scene,
    null,
    { loop: false, volume: volumeSoundtrack, autoplay: false }
  );


  const switchStuck = new BABYLON.Sound(
    "switchStuck",
    window.pakopeliPublicAssetUrl + "sound/converted/FXkytkinjumissa.mp3",
    scene,
    null,
    { loop: false, volume: volumeSoundtrack, autoplay: false }
  );


  const switchOpen = new BABYLON.Sound(
    "switchOpens",
    window.pakopeliPublicAssetUrl + "sound/converted/FXkytkinaukeaa.mp3",
    scene,
    null,
    { loop: false, volume: volumeSoundtrack, autoplay: false }
  );


  const cameraLockerButtonActive = new BABYLON.Sound(
    "cameraLockerButtonActive",
    window.pakopeliPublicAssetUrl + "sound/converted/ES_Beep_Tone_Signal_13_-_SFX_Producer.mp3",
    scene,
    null,
    { loop: false, volume: volumeSoundtrack, autoplay: false }
  );


  const cameraLockerButtonDeactive = new BABYLON.Sound(
    "cameraLockerButtonDeactive",
    window.pakopeliPublicAssetUrl + "sound/converted/ES_Beep_Tone_Signal_12_-_SFX_Producer.mp3",
    scene,
    null,
    { loop: false, volume: volumeSoundtrack, autoplay: false }
  );

  const cameraBrowsing = new BABYLON.Sound(
    "cameraBrowsing",
    window.pakopeliPublicAssetUrl + "sound/converted/ES_Switch_Click_4_-_SFX_Producer.mp3",
    scene,
    null,
    { loop: false, volume: volumeSoundtrack, autoplay: false }
  );

  const clockMinutes = new BABYLON.Sound(
    "clockMinutes",
    window.pakopeliPublicAssetUrl + "sound/converted/ES_Switch_Click_4_-_SFX_Producer.mp3",
    scene,
    null,
    { loop: false, volume: volumeSoundtrack, autoplay: false }
  );

  const clockAnimationSound= new BABYLON.Sound(
    "clockAnimation",
    window.pakopeliPublicAssetUrl + "sound/converted/clock_animation.mp3",
    scene,
    null,
    { loop: false, volume: (volumeSoundtrack - 0.1), autoplay: false }
  );

  const electricWire = new BABYLON.Sound(
    "electricWire",
    window.pakopeliPublicAssetUrl + "sound/converted/ES_Screwdriver_Drill_1_-_SFX_Producer.mp3",
    scene,
    null,
    { loop: false, volume: volumeSoundtrack, autoplay: false }
  );

  const generalComputerSound = new BABYLON.Sound(
    "generalComputerSound",
    window.pakopeliPublicAssetUrl + "sound/converted/ES_Note_Remove_-_SFX_Producer.mp3",
    scene,
    null,
    { loop: false, volume: volumeSoundtrack, autoplay: false }
  );


/*   scene.getSoundByName("musicFl").dispose();
  scene.getSoundByName("musicWh").dispose();
  scene.getSoundByName("musicBk").dispose(); */
/*   musicExit.dispose(); */
  if(mobileOrNot()) {
  footSteps.dispose();
  }
  return {
    electricPanelSoundSet,
    exitDoorsSoundSet,
    bunkerDoorSound,
    warehouseDoorSound,
    tvSound,
    fcDoorSound,
    computerSound4,
    computerSound3,
    computerSound2,
    computerSound,
    musicBunker,
    musicWarehouse,
    musicFlat,
    paperMovement,
    paperRightPlace,
    matrixKeyboard,
    exitDoorNotOpen
  };
};

export { createSounds };

//#endregion
